/**
 * Shared module-level mutation cooldown.
 *
 * When any local mutation (create/update/delete) patches the RTK Query cache,
 * it calls `markMutation()` to record the timestamp. The realtime subscription
 * in useDraftScheduleData skips refetching if a mutation occurred within
 * COOLDOWN_MS, since the cache is already up-to-date.
 */

const COOLDOWN_MS = 5000;

let lastMutationTime = 0;

/** Call after any local cache-patching mutation. */
export function markMutation(): void {
  lastMutationTime = Date.now();
}

/** Returns true if a local mutation happened within the cooldown window. */
export function isInMutationCooldown(): boolean {
  return Date.now() - lastMutationTime < COOLDOWN_MS;
}
